var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrobaAzul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_415_55066",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_415_55066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5C10.6872 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74942 15.7035 3.24825C16.8597 3.74692 17.8653 4.42375 18.7205 5.27875C19.5757 6.13375 20.2528 7.13917 20.7518 8.295C21.2506 9.45083 21.5 10.6858 21.5 12V13.2192C21.5 14.1321 21.1866 14.9071 20.5598 15.5443C19.9329 16.1814 19.163 16.5 18.25 16.5C17.6602 16.5 17.1133 16.3558 16.6095 16.0673C16.1057 15.7788 15.7076 15.3819 15.4152 14.8767C14.9832 15.3923 14.4727 15.7917 13.8837 16.075C13.2946 16.3583 12.6667 16.5 12 16.5C10.7513 16.5 9.68917 16.0622 8.8135 15.1865C7.93783 14.3108 7.5 13.2487 7.5 12C7.5 10.7513 7.93783 9.68917 8.8135 8.8135C9.68917 7.93783 10.7513 7.5 12 7.5C13.2487 7.5 14.3108 7.93783 15.1865 8.8135C16.0622 9.68917 16.5 10.7513 16.5 12V13.2192C16.5 13.7102 16.6689 14.1298 17.0068 14.478C17.3446 14.826 17.759 15 18.25 15C18.741 15 19.1554 14.826 19.4932 14.478C19.8311 14.1298 20 13.7102 20 13.2192V12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20H17V21.5H12ZM12 15C12.8333 15 13.5417 14.7083 14.125 14.125C14.7083 13.5417 15 12.8333 15 12C15 11.1667 14.7083 10.4583 14.125 9.875C13.5417 9.29167 12.8333 9 12 9C11.1667 9 10.4583 9.29167 9.875 9.875C9.29167 10.4583 9 11.1667 9 12C9 12.8333 9.29167 13.5417 9.875 14.125C10.4583 14.7083 11.1667 15 12 15Z",
    fill: "#00BDD9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrobaAzul);
export default __webpack_public_path__ + "static/media/arroba-azul.acc4d4a193897a7a04a5e22790e13df2.svg";
export { ForwardRef as ReactComponent };